import React from 'react';
import notifier from '../../../_utils/notifier';

const copy = require('clipboard-copy');

const RefferalLink = ({ invite_link }) => {
  const handleClick = () => {
    copy(invite_link);
    notifier.success(gettext('Ссылка успешно скопирована'));
  };

  return (
    <div className="form-group">
      <label htmlFor="inputInvite" className="font-weight-bold">{ gettext('Ссылка для приглашений') }:</label>
      <p className="small text-secondary">
        { gettext('Приглашайте своих учеников и коллег с помощью этой ссылки на данный проект ' +
          'и вы будете получать бонус от 3 до 5% со всех их покупок навсегда.') }</p>
      <div className="input-group">
        <input type="text" className="form-control" id="inputInvite" readOnly="readonly" value={ invite_link }/>
          <div className="input-group-append">
            <button className="btn btn-outline-secondary"
                    type="button"
                    title={ gettext('Скопировать ссылку') }
                    onClick={ handleClick }>
              <i className="icon icon-floppy"></i></button>
          </div>
      </div>
    </div>
  )
}

export default RefferalLink;
